export default __webpack_public_path__ + "static/ReklamaDlaBiznesu-e1f25fbb0cf23c50920a0d399ee76e93.svg";